import { Component, Vue, Prop } from "vue-property-decorator";
import _com from "../../../assets/js/common";
import _intercept from "../../../assets/js/intercept";

@Component
export default class couponModal extends Vue {
	@Prop() private userEnterTime!: any;
	conponType: any = {
		"1": "店铺券",
		"2": "商品券",
		"3": "运费券",
		"4": "充值券",
		"5": "通用券",
		"6": "品类券",
	};
	getItems: any = [];

	getCouponApi: string = "//m" + this.domain + "/mact/live/getCoupon";
	coupon_time: any = ''
	autoCoupons: any = []
	couponDataOld: any = []
	get isChangeConpon() {
		return this.$store.getters["environment/getIsChangeConpon"];
	}
	get couponData() {
		let arr = []
		//判断系统优惠券是否新增
		let getAutoCoupons = this.$store.getters["refresh/getAutoCoupons"];
		if (getAutoCoupons.length > this.autoCoupons.length) {
			arr = getAutoCoupons.slice(this.autoCoupons.length)
			arr.forEach((cou: any) => {
				cou.newFlag = 1
			});
		}
		this.autoCoupons = getAutoCoupons
		//判断用户优惠券是否变化
		let useCoupon = this.$store.getters["refresh/getCoupons"];
		let roomData = this.$store.getters["refresh/getFollow"];
		let nowDate = new Date().getTime();
		//						  有新增优惠券											修改时间与上次的不一致							设置时间为三分钟内的								用户进入后设置的
		if (useCoupon.length > 0 && useCoupon[0].newFlag == 1 && roomData.coupon_time && this.coupon_time != roomData.coupon_time && ((nowDate - roomData.coupon_time) < 3 * 60 * 1000) && this.userEnterTime < roomData.coupon_time) {
			this.coupon_time = roomData.coupon_time;
			arr = arr.concat(useCoupon)
		}
		if (getAutoCoupons.length == 0 && useCoupon.length == 0) {
			this.$store.dispatch("environment/getIsChangeConponAsync", false);
		}
		if (arr.length > 0) {
			this.couponDataOld = arr
			this.$store.dispatch("environment/getIsChangeConponAsync", true);
		} else {
			arr = this.couponDataOld
		}
		return arr
	}

	stop(e: any) {
		e.stopPropagation();
	}
	close() {
		this.$store.dispatch("environment/getIsChangeConponAsync", false);
	}

	timeInter: any;
	mounted() {
		if (this.$route.name == 'couponModal') {
			this.$store.dispatch("refresh/getRecommendAsync", {
				roomNumber: this.$route.params.roomNumber,
				source: this.$route.params.source || this.source
			}
			);
			let timeNum = 0;
			clearInterval(this.timeInter);
			this.timeInter = setInterval(() => {
				//定时5秒获取一次弹幕
				timeNum++;
				if (timeNum % 10 == 0) {
					timeNum = 0;
					this.$store.dispatch("refresh/getRecommendAsync", {
						roomNumber: this.$route.params.roomNumber,
						source: this.$route.params.source || this.source
					}
					);
				}
			}, 1000)
		}

	}

	getCoupon(item: any) {
		if (!_intercept()) {
			return false;
		}
		this.$http
			.jsonp(this.getCouponApi, {
				params: {
					batchId: item.batchIdCipher,
					receiveChannelCode: "APP_COUPON_WALL",
					receiveAddress: location.href,
				},
				jsonp: "jsonCallback",
			})
			.then((res: any) => {
				res = res.body;
				if (res.code == "0000") {
					this.$toast("领取成功");
					this.getItems.push(item.batchId);
					this.$forceUpdate();
				} else {
					if (res.code == '2013') {//券已领完
						item.stock = 0
					}
					this.$toast(res.msg);
				}
			});
		// 领券埋点

		let sysid: any = ''
		if (navigator?.userAgent.includes('SYSID')) {
			sysid = navigator.userAgent.split('SYSID/')[1]
		}
		let roomData: any = this.$store.getters["getRoomDetail/getRoomDetail"];
		let scene_number = ''
		if (roomData) scene_number = roomData.scene_number
		_com.sendSensorTrack('CouponsReceive', {}, {
			batchId: item.batchId,
			sysid,
			scene_number,
			couponType: this.conponType[item.couponType],
			couponName: item.amount + '元优惠券'
		})
	}

	toUseConpon(item: any) {
		this.$store.dispatch("environment/getIsChangeConponAsync", false);
		item.title = item.amount + "元商品券(不限金额使用)";
		this.$store.dispatch("environment/setBatchObjAsync", item);
		this.$store.dispatch("environment/getIfBatchTitleAsync", true);
		this.$store.dispatch("environment/getIsGoodsListAsync", true);
		this.$emit("useConpon");
	}
}
